import { mapGetters } from 'vuex'
import { messageChannelEmit } from '@core/utils/message'
import routeTypeMixin from '@/components/content/routeTypeMixin'

export default {
  data() {
    return {}
  },
  mixins: [routeTypeMixin],
  computed: {
    ...mapGetters('content', ['contentTabIndex'])
  },
  methods: {
    onDownloadCsv() {
      messageChannelEmit(`downloadCsv${this.contentTabIndex}:${this.routeType()}`)
    }
  }
}
